<script>
  import { onMount, createEventDispatcher } from 'svelte';
  import { sortCharacters, getRelationship } from './utilities.js';

  let characters = [];
  let character1, character2;

  onMount(async () => {
    const res = await fetch('data/relationships.json');
    characters = sortCharacters(await res.json());
  });

  const dispatch = createEventDispatcher();

  const handleChange = () => {
    if (character1 && character2) {
      const relationship = getRelationship(characters[character1 - 1], characters[character2 - 1]);
      dispatch('relationshipPopup', relationship);
    }
  };
</script>

<style>
  .relationship-select {
    padding: 2em 0;
  }
</style>

{#if characters.length}
<div class="relationship-select">
  <h2>Select two actors to see relationship</h2>
  <div>
    <select name="character1" bind:value={character1} on:blur={handleChange}>
      <option value="">- Select character 1 -</option>
      {#each characters as character, i}
        <option value="{ (i + 1) }" disabled="{(i + 1) == character2 ? 'disabled':'' }">{ character.name }</option>
      {/each}
    </select>
  </div>

  <div>
    <select name="character2" bind:value={character2} on:blur={handleChange}>
      <option value="">- Select character 2 -</option>
      {#each characters as character, i}
        <option value="{ (i + 1) }" disabled="{(i + 1) == character1 ? 'disabled':'' }">{ character.name }</option>
      {/each}
    </select>
  </div>
</div>
{/if}